import { render, staticRenderFns } from "./CardGrafic.vue?vue&type=template&id=1897486c"
import script from "./CardGrafic.vue?vue&type=script&lang=js"
export * from "./CardGrafic.vue?vue&type=script&lang=js"
import style0 from "./CardGrafic.vue?vue&type=style&index=0&id=1897486c&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/hive-platform-web/hive-platform-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1897486c')) {
      api.createRecord('1897486c', component.options)
    } else {
      api.reload('1897486c', component.options)
    }
    module.hot.accept("./CardGrafic.vue?vue&type=template&id=1897486c", function () {
      api.rerender('1897486c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CardGrafic.vue"
export default component.exports